<div class="question-pull" [id]="'specified-items-accordion'">
  @for (item of enteredItems; track item; let i = $index; let last = $last) {
    <div class="card card--freeform">
      <a [href]="'#' + (item?.Description ? removeSpaces(item?.Description) : 'add-item') + '-' + (i +1)"
        class="card-title"
        data-toggle="collapse" aria-expanded="false" [class.collapsed]="item.Description || !last">
        <div class="card-title__text">
          <svg class="icon icon--lg">
            <use [attr.xlink:href]="'#cart-discount'"></use>
          </svg>
          <div class="card-title__text-wrap">
            <h4>{{item?.Description ? item?.Description : 'Add item'}}</h4>
            <p>{{item?.Category}}</p>
          </div>
        </div>
        <div class="card-title__cost is-active">
          @if (processing) {
            <p><strong>...</strong> /mo</p>
          }
          @if (!processing) {
            <p><strong>{{questionService.accounting.formatMoney(item?.Premium)}}</strong> /{{questionService.currency?.display_freq}}</p>
          }
        </div>
        <div class="card-title__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
      <div class="card-body collapse"
        [id]="(item?.Description ? removeSpaces(item?.Description) : 'add-item') + '-' + (i +1)"
        [attr.data-parent]="'#specified-items-accordion'" [class.show]="!item.Description || last">
        <div class="card__content">
          <div class="form-group form-group--sm ui-front">
            <app-question-dropdown
              [options]="options"
              [showLabel]="true"
              [labelText]="'Specify type of item'"
              [selectedValue]="item.Category"
              (questionAnswer)="selectChange($event, i)">
            </app-question-dropdown>
          </div>
          <div class="form-group form-group--sm">
            <label>Describe Item</label>
            <input type="text" placeholder="Add Description" [(ngModel)]="item.Description" class="form-control"
              (blur)="onInputChange(i)" [name]="uniqueDescriptionName + '-' + i">
            </div>
            <div class="form-group form-group--sm">
              <label>Specify insurance amount</label>
              <!-- <input type="text" placeholder="R 1 000 - R 1 000 000" class="form-control currency" autocomplete="off"
              (blur)="onInputChange(i)"> -->
              <input
                currencyMask type="text" class="form-control currency" autocomplete="off"
                [name]="uniqueAmountName + '-' + i"
                [(ngModel)]="item.Amount" (blur)="onInputChange(i)"
            [placeholder]="questionService.accounting.formatMoney(question?.min_val) + ' - ' +
            questionService.accounting.formatMoney(question?.max_val)"
                [options]="maskOptions">
              </div>
            </div>
          </div>
        </div>
      }
      <!-- /card -->
    </div>
